import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useCallback } from 'react';
import { SearchBox, Input, Combobox } from '@zillow/constellation';
import options from './installations.js';

var _excluded = ["onClear", "onTagClose"];
var OPTIONS = options.installations;
var MilitaryInstallationSelector = function MilitaryInstallationSelector(_ref) {
  var onChange = _ref.onChange;
  var handleChange = function handleChange(value, meta) {
    typeof onChange === 'function' && onChange(value, meta);
  };
  var renderInput = useCallback(function (_ref2) {
    _ref2.onClear;
      _ref2.onTagClose;
      var rest = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement(SearchBox, {
      input: /*#__PURE__*/React.createElement(Input, _extends({
        placeholder: "Start typing installation name"
      }, rest))
    });
  }, []);
  return /*#__PURE__*/React.createElement(Combobox, {
    onChange: handleChange,
    options: OPTIONS,
    renderInput: renderInput,
    showLabelForValue: true
  });
};
var MilitaryInstallationSelector$1 = MilitaryInstallationSelector;

export { MilitaryInstallationSelector$1 as default };
